import { Reducer as Reducer_ } from 'redux';
import CurrentApplication_ from '../../data/models/CurrentRequestApplication';
import { SET_CURRENT_APPLICATIONS } from '../actions/actionTypes/current-applications';
import { ICurrentApplicationsActionType as ICurrentApplicationsActionType_ } from '../actions/current-applications-actions';

const currentApplicationsReducer: Reducer_<CurrentApplication_[], ICurrentApplicationsActionType_> = (state = [], { type, payload, }) => {
  switch (type) {
    case SET_CURRENT_APPLICATIONS:
      return payload;
    default:
      return state;
  }
};

export default currentApplicationsReducer;
